import { Person } from 'app/fs/res/common/model/person/person';
import { GenericValue } from 'hisng';

export class DocumentMetadata {
    id: number;

    target: string;
    targetId: number;

    fileName: string;
    createdAt: string | Date;
    createdBy: Person;
    category: GenericValue;

    visibility: GenericValue;
    mimedata: Mimedata;
    objGuid: string;

    markForDelete: boolean; // frontend only attribute

    uploadedResource?: HisResource;

    constructor( target?: string, targetId?: number, mimedata?: Mimedata ) {
        this.target = target;
        this.targetId = targetId;
        this.mimedata = mimedata;
    }
}

export class HisResource {
    name: string;
    contentType: string;
}

export class Mimedata {
    id: number;
    description: string;
    createdAt: string | Date;
    mimeType: string;
}
